import type { FeedEntry } from "./types"

export interface DayGroup {
  key: string
  label: string
  entries: FeedEntry[]
}

export function groupByDay(entries: FeedEntry[]): DayGroup[] {
  const groups: DayGroup[] = []
  // Assumes entries are already day-contiguous (API is newest-first); only compares against the last group.
  for (const e of entries) {
    const d = new Date(e.created_at)
    const key = d.toDateString()
    const label = d.toLocaleDateString(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
    })
    let g = groups[groups.length - 1]
    if (!g || g.key !== key) {
      g = { key, label, entries: [] }
      groups.push(g)
    }
    g.entries.push(e)
  }
  return groups
}
